// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"349":"email-editor","552":"chartjs"}[chunkId] || chunkId) + "-" + {"94":"3d3555571bd1b127168f","349":"e286f1bbf4ffa5e177d5","492":"bb7659330abc030ba62a","552":"7529a734f7c94c790d73","818":"037f1dc2431f5d9e4f0b"}[chunkId] + ".chunk.js";
};